export * from './images'

// максимальное кол-во отображаемых призов
export const VIEW_PRIZES_LENGTH = 27

export const OLD_LOGIC = true
